import { Truck, Package, Ship, Anchor, MapPin, FileCheck, Check, RotateCcw } from 'lucide-react';

// Container lifecycle operations — keys match CONTAINER_OPERATIONS in backend/models/schemas.py
export const CONTAINER_OPERATIONS = {
  gate_out_empty: { label: 'Gate Out (Empty)', icon: Truck, description: 'Release empty container to shipper' },
  gate_in_full: { label: 'Gate In (Loaded)', icon: Package, description: 'Receive loaded container at terminal' },
  loaded_on_vessel: { label: 'Load on Vessel', icon: Ship, description: 'Container loaded onto vessel' },
  vessel_departed: { label: 'Vessel Departed', icon: Anchor, description: 'Vessel has departed origin port' },
  in_transit: { label: 'In Transit Update', icon: MapPin, description: 'Update location during transit' },
  vessel_arrived: { label: 'Vessel Arrived', icon: Anchor, description: 'Vessel arrived at destination' },
  unloaded: { label: 'Unloaded', icon: Package, description: 'Container unloaded from vessel' },
  customs_clearance: { label: 'Customs Cleared', icon: FileCheck, description: 'Container cleared customs' },
  gate_out_delivery: { label: 'Gate Out (Delivery)', icon: Truck, description: 'Released for final delivery' },
  delivered: { label: 'Delivered', icon: Check, description: 'Delivered to consignee' },
  empty_returned: { label: 'Empty Returned', icon: RotateCcw, description: 'Empty container returned to depot — stops detention' },
};
